import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "text", "title", "containerId", "content", "closeButton", "closeButtonClassName", "useDefaultCloseButton"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { toast } from 'react-toastify';
import ToastMessage from './ToastMessage';
import CustomCloseButton from './CustomCloseButton';
import Icon from '../../general/Icon';
var TOAST_TYPES = {
  success: toast.TYPE.SUCCESS,
  info: toast.TYPE.INFO,
  error: toast.TYPE.ERROR,
  warning: toast.TYPE.WARNING
};
var handleCloseToast = function handleCloseToast(closeToast) {
  return function (e) {
    e.preventDefault();
    e.stopPropagation();
    closeToast();
  };
};
var renderDefaultCloseButton = function renderDefaultCloseButton(_ref) {
  var closeToast = _ref.closeToast;
  return /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    size: "large",
    onClick: handleCloseToast(closeToast)
  });
};
var showToast = function showToast(props) {
  var _props$type = props.type,
    type = _props$type === void 0 ? 'info' : _props$type,
    _props$text = props.text,
    text = _props$text === void 0 ? '' : _props$text,
    _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    containerId = props.containerId,
    content = props.content,
    closeButton = props.closeButton,
    closeButtonClassName = props.closeButtonClassName,
    useDefaultCloseButton = props.useDefaultCloseButton,
    newProps = _objectWithoutProperties(props, _excluded);
  if (content) {
    var properties = {
      closeButton: closeButton || false,
      closeButtonClassName: closeButtonClassName,
      useDefaultCloseButton: useDefaultCloseButton
    };
    return toast(content, _objectSpread({
      containerId: containerId || 'hoi-poi-ui',
      closeButton: /*#__PURE__*/React.createElement(CustomCloseButton, {
        properties: properties
      })
    }, newProps));
  }
  var toastType = TOAST_TYPES[type];
  var messageProps = {
    title: title,
    text: text,
    type: type
  };
  var defaultCloseButton = useDefaultCloseButton ? renderDefaultCloseButton : null;
  return toast( /*#__PURE__*/React.createElement(ToastMessage, messageProps), _objectSpread({
    type: toastType,
    containerId: containerId || 'hoi-poi-ui',
    closeButton: defaultCloseButton || closeButton || false
  }, newProps));
};
export default showToast;